import service from './axios';
export const getParkProjects = (params = {}) => service.get('/manage/park-projects', { params });
export const getParkProject = (id) => service.get(`/manage/park-projects/${id}`);
export const createParkProject = (d) => service.post('/manage/park-projects', d);
export const updateParkProject = (id, d) => service.put(`/manage/park-projects/${id}`, d);
export const deleteParkProject = (id) => service.delete(`/manage/park-projects/${id}`);
